import React from "react";
import "./StepItem.css";

// 🔹 Added hasOpenIssue to props
function StepItem({ stepText, hasRemark, isNew, hasOpenIssue, onClick }) {
  // ⚡ Fixed: Removed unused 'nodeName' variable string extraction

  return (
    <div
      className="step-item"
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        padding: "8px 16px",
        cursor: "pointer",
        userSelect: "none",
        transition: "background 0.15s",
      }}
    >
      {/* 🔴 Red dot shows when the node issue status = open */}
      {hasOpenIssue && (
        <span
          className="red-dot"
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            backgroundColor: "red",
            marginRight: "8px",
          }}
        />
      )}

      {/* 🔹 Text color logic */}
      <span
        className="step-text"
        style={{
          flex: 1,
          color: hasOpenIssue ? "red" : "#1976d2",
          fontWeight: hasOpenIssue ? "bold" : "normal",
        }}
      >
        {stepText}
      </span>

      {/* Arrow */}
      <span className="arrow" style={{ marginLeft: "8px", color: "#ccc" }}>
        ▶
      </span>
    </div>
  );
}

export default StepItem;